import { IPreloadedState } from 'shared/types/redux';
import { selectSearchMetaData } from '../searchMeta';
import { isEmpty } from 'ramda';

export const selectIsSearchMetaTooltipAvailable = (state: IPreloadedState) => {
  const isAvailable = state.searchMetaTooltip.isAvailable;
  const searchMeta = selectSearchMetaData(state);

  return !isEmpty(searchMeta) && isAvailable;
};
